<template>
  <b-card
  :header-bg-variant="showErrorState ? 'danger': null"
  :border-variant="showErrorState ? 'danger': null"
  body-class="py-1 px-2"
  header-class="py-1 px-2"
  class="mb-0"
  :header="label"
  :header-class="force && 'text-danger'"
  >
    <div v-for="file in filePaths" :key="file" class="my-1">
      <b-btn variant="info" size="sm" target="_blank"
        v-if="check == true"
        :href="`${$config.files.baseurlimage}${file}`">
        <font-awesome-icon icon="eye"/>
        {{$t('shared.View')}}
      </b-btn>
    
      <img v-else :src="`${$config.files.baseurlimage}${file}`" class="border"> 

      <b-btn variant="danger" size="sm" class="mx-2" @click="deleteFile(file)">
        <font-awesome-icon icon="trash"/>
      </b-btn>
    </div>
    <div v-if="multiple || !filePaths.length" class="my-1">
      <input type="file" name="file" ref="input" v-show="false"
      :multiple="multiple"
      @change="onChangeInputFile"
      :accept="accept"
      :disabled="uploading"/>
      <div style="overflow:auto">
        <b-btn :variant="uploading ? 'success' : 'secondary'" @click="openBrowse" size="sm" :class="$dir.rtl ? 'float-right ml-2' : 'float-left mr-2'">
          <font-awesome-icon :icon="uploading ? 'cog' : 'cloud-upload-alt'" :spin="uploading" class="mx-1 align-middle" />
          {{uploading ? $t('forms.Uploading') : $t('forms.ChooseFile')}}
        </b-btn>
        <b-progress class="mt-2" :value="progress" variant="success" striped :animated="uploading"/>
      </div>
    </div>
    <hr class="mt-2 mb-0" v-if="!!uploadErrors.length" />
    <b-alert class="mb-1 mt-2" variant="danger" show v-for="error in uploadErrors" :key="error">
      {{error}}
    </b-alert>
  </b-card>
</template>

<script>
import { scaleImage } from '@/lib/images.js'

export default {
  name: 'Uploader',
  props: {
    value: { type: String },
    label: { type: String },
    force: { type: Boolean },
    uploadMaxSize: { type: Number, default: 1073741824 }, // 1073741824 bytes = (1 Gig)
    autoScale: { type: Number, default: null }, // pixels
    hasError: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    accept: { type: String, default: '.png,.jpg,.jpeg,.svg,.gif,.apk' },
    docUploadModel: {type: Object, default () {return null} }
  },
  data () {
    return {
      progress: 0,
      filePaths: [],
      uploadErrors: [],
      check:null
    }
  },
  computed: {
    showErrorState () {
      return this.hasError || !!this.uploadErrors.length
    },
    uploading () {
      return this.progress > 0
    }
  },
  watch: {
    value: function (newVal, oldVal) { // watch it
      if (newVal) {
        this.filePaths = newVal.split(',')
      } else {
        this.uploadErrors = []
      }
    },
    accept (newVal, oldVal) {
      if (newVal !== oldVal) this.checkExtensions()
    }
  },
  mounted () {
    if (this.value) {
      this.filePaths = this.value.split(',')
    }

    this.checkExtensions()
  },
  methods: {
    checkExtensions () {
      this.uploadErrors = []
      if (this.value && this.value.length) {
        this.value.split(',').forEach(f => {
          const ex = f.toLowerCase().split('.').pop()
          if (!this.accept.toLowerCase().includes(ex)) {
            this.uploadErrors.push(this.$t('forms.File_extension_not_accepted', { fileName: f, accepted: this.accept }))
          }
        })
      }
    },
    openBrowse () {
      this.$refs.input.click()
    },
    onChangeInputFile (e) {
      this.uploadErrors = []

      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const ex = file.name.toLowerCase().split('.').pop()
        if (this.accept !== '*.*' && !this.accept.toLowerCase().includes(ex)) {
          this.uploadErrors.push(this.$t('forms.File_extension_not_accepted', { fileName: file.name, accepted: this.accept }))
          return
        } else if (file.size > this.uploadMaxSize) {
          this.uploadErrors.push(this.$t('forms.File_max_size_exceeded', { fileName: file.name, maxSize: Math.floor(this.uploadMaxSize / 1024) }))
          return
        }
      }

      if (this.autoScale) {
        const scales = []
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          if (file.type.match(/image.*/)) {
            scales.push(scaleImage(file, this.autoScale))
          } else {
            scales.push(file)
          }
        }
        Promise.all(scales).then(all => this.upload(all))
      } else {
        this.upload(files)
      }
    },
    upload (files) {
      this.progress = 0.1
      let promise
      if (this.docUploadModel) {
        promise = this.docUploadModel.api.upload(this.docUploadModel.type, this.docUploadModel.path, files, this.onProgress)
        .then(res => {
          res.forEach(file => {
            this.filePaths.push(file.url.substring(1))
          })
        })
      } else {
        promise = this.$api.files.upload(files, this.onProgress, true)
        .then(res => {
          res.forEach(fileName => {
            this.filePaths.push(`${fileName}`)
            if (fileName.includes('.apk')) {
                this.check = false
              }else{
              this.check = true
              }
          })
        })
      }
      promise
      .then(() => { 
        this.onChange()
        this.emitInput()
        this.progress = 0
        this.cleanInput()
      })
      .catch(e => {
        this.uploadErrors.push(e.message)
        this.progress = 0
        this.cleanInput()
      })
    },
    emitInput () {
      const value = this.filePaths.length ? this.filePaths.toString() : null
      this.$emit('input', value)
    },
    cleanInput () {
      if(this.$refs.input) this.$refs.input.value = ''
    },
    onProgress (e) {
      this.progress = parseInt(e.loaded * 100 / e.total)
      this.$emit('progress', this.progress)
    },
    onChange () {
      this.$emit('change', this.filePaths)
    },
    deleteFile (filePath) {
      if (confirm(this.$t('forms.AreYouSureToRemoveThisFile'))) {
        if (filePath.startsWith('Temp/')) {
          const fileName = filePath.split('/')[1]
          this.$api.files.delete(fileName, true)
        }
        this.filePaths = this.filePaths.filter(f => f !== filePath)
        this.onChange()
        this.emitInput()
      }
    }
  }
}
</script>
